import ZoomIn from 'components/Icons/ZoomIn';
import ZoomOut from 'components/Icons/ZoomOut';
import ECSEditorContext from 'contexts/ECSEditorContext';
import ECSWorldContext from 'contexts/ECSWorldContext';
import UpdateZoom from 'editor/components/UpdateZoom';
import React, { FC, useContext } from 'react';
import './toolbar.css';

const ZoomControls: FC = () => {
  const world = useContext(ECSWorldContext);
  const { doc: carnDoc } = useContext(ECSEditorContext);

  function handleZoomIn() {
    // TODO: Will need to add Doc and Sheet components to this entity.
    world.createEntity().add(carnDoc).add(new UpdateZoom('in'));
  }

  function handleZoomOut() {
    // TODO: Will need to add Doc and Sheet components to this entity.
    world.createEntity().add(carnDoc).add(new UpdateZoom('out'));
  }

  return (
    <div className="toolbar zoom-controls">
      <div className="tool" onClick={handleZoomIn}>
        <div className="wrem-1p5 hrem-1p5 flex-center">
          <ZoomIn width="16px" height="16px" />
        </div>
      </div>
      <div className="tool" onClick={handleZoomOut}>
        <div className="wrem-1p5 hrem-1p5 flex-center">
          <ZoomOut width="16px" height="16px" />
        </div>
      </div>
    </div>
  );
};

export default ZoomControls;
